import React, { useState } from 'react';
import ImageAltText from './ImageAltText';
import ImageCaption from './ImageCaption';
import { restrictUserInput } from '../../helpers/utilities';

function ExistingImage(props) {
    const { uploadedMedia, instanceNumber, allowImages, handleCallback } = props;
    const [descriptionText, setDescriptionText] = useState(
        uploadedMedia.description ? uploadedMedia.description : ""
    );
    const [captionText, setCaptionText] = useState(
        uploadedMedia.caption ? uploadedMedia.caption : ""
    );

    function handleUserInput(input, isCaptionText) {
        const textValue = restrictUserInput(input, isCaptionText);
        isCaptionText ? setCaptionText(textValue) : setDescriptionText(textValue);
    }

    return (
        <>
            {
                <div
                    id={`Uploader${instanceNumber}`}
            className="ugc-contribution-modal__uploader ugc-contribution-modal__uploader-container"
                    key={`Uploader${instanceNumber}`}>
                    <input type="hidden"
                        id={`Url${instanceNumber}`}
                        name="uploadUrls"
                        value={uploadedMedia.url} />
                    <input type="hidden"
                        id={`filename${instanceNumber}`}
                        name="filenames"
                        value={uploadedMedia.filename} />
                    <div
                        id={`preview${instanceNumber}`}
                        className="he-grid-row">
                        <div className="he-grid-col-md-6">
                            <div
                                className="ugc-contribution-modal__upload-image-wrapper">
                                <img
                                    id={`imagePreview${instanceNumber}`}
                                    src={uploadedMedia.url}
                                    alt="User Submitted" />
                            </div>
                        </div>
                        <ImageCaption
                            instanceNumber={instanceNumber}
                            captionText={captionText}
                            restrictUserInput={(input) => handleUserInput(input, true)}
                        />
                        <ImageAltText
                            instanceNumber={instanceNumber}
                            descriptionText={descriptionText}
                            restrictUserInput={(input) => handleUserInput(input, false)}
                        />
                    </div>
                    {
                        allowImages &&
                        <div className="ugc-contribution-modal__uploader--image-loaded">
                            <button
                                type="button"
                                className="govuk-button he-button he-button__neutral ugc-contribution-modal__uploader--image-loaded-button"
                                onClick={(e) => {
                                    handleCallback(instanceNumber);
                                }}>
                                Remove
                            </button>
                        </div>
                    }
                </div>
            }
        </>
    );
}

export default ExistingImage;
